import axios from 'axios'

axios.defaults.headers.common = {
  ...axios.defaults.headers.common,
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL

axios.interceptors.request.use(config => {
  if (window.localStorage.vuex) {
    const state = JSON.parse(window.localStorage.vuex)
    if (state && state.auth.isUserLoggedIn) {
      config.headers.common.Authorization = `Bearer ${state.auth.userAuthInfo.token}`
    }
  }
  return config
}, (error) => {
    return Promise.reject(error)
})

export default axios